import { useState,useEffect } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import config from './config';

function App() {
	
	const [data, setData] = useState([]);
	
	const url = `https://sheets.googleapis.com/v4/spreadsheets/${config.spreadsheetId }/values:batchGet?ranges=FataFat Intraday Scan&majorDimension=ROWS&key=${config.apiKey}`;
	
	useEffect(() => {
	async function getData() {
		await fetch(url).then(response => response.json()).then(data => {
			console.log("fetched");
			let rowValues = data.valueRanges[0].values;
			
			let sourceData=[];
			for(let j=2;j<rowValues.length;j++){
				let dataObj={};
				dataObj["id"]=j;
				for(let k=0;k<rowValues[j].length;k++){
					if(k==0){
						dataObj["stocks"]=rowValues[j][k];						
					}
					else if(k==1){
						dataObj[rowValues[0][k]]="https://www.google.com/finance/quote/"+dataObj["stocks"]+":NSE";
						//dataObj[rowValues[0][k]]="https://www.google.com/finance?q=NSE:"+dataObj["stocks"];
					}
					else{
						dataObj[rowValues[0][k]]=rowValues[j][k];
					}
				}
				sourceData.push(dataObj);
			}
			//console.log(sourceData);
			setData(sourceData);
		});
    }
    getData();
	
	//setInterval(() => getData(), 8000);
  }, [0]);
	
	const styledHead = (val) => {return {width: val+"px",textAlign:"center",position: "sticky",top: 0,backgroundColor: '#ccc'}};
	const styledVal = (cellContent) => {
		//console.log(cellContent);
		if(cellContent !== undefined){
			if(cellContent.includes("RUNWAY") || cellContent.includes("WATCH") || cellContent.includes("PIVOT"))
				return{ color: '#651fff'};//#fff59d
			else if (cellContent.includes("UP")|| cellContent[0]>=0 || cellContent.includes("ABOVE") || cellContent.includes("HIGH")|| cellContent.includes("ABV"))
				return{ color: '#64dd17'};//#b2ff59
			
			else if(cellContent.includes("DOWN")||  cellContent[0]==="-" || cellContent<0 || cellContent.includes("BELOW") || cellContent.includes("LOW")|| cellContent.includes("BLW"))
				return{ color: '#ff3d00'};//#ff5722
		}
	};	
	
	const columns = [
		{id:"1",dataField: "stocks", text: "Stocks",
			headerStyle: {width:"100px",whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 0, zIindex: 1},
			style: {width:"100px",whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 0, zIindex: 1},
			filter: textFilter(),
			align: "center",
			sort: true
		},
		{id:"2",dataField: "CHART", text: "CHART",
			headerStyle: styledHead(80),
			formatter: (cell,row,columnIndex) => <a target="_blank" href={cell}> CHART </a>,
			align: "center"
		},
		{id:"3",dataField: "RATING", text: "RATING",
			headerStyle: styledHead(90),
			align: "center",
			sort: true
		},
		{id:"4",dataField: "SECTOR", text: "SECTOR",
			headerStyle: styledHead(100),
			filter: textFilter(),
			align: "center",
			sort: true
		},
		{id:"5",dataField: "CMP", text: "CMP",
			headerStyle: styledHead(80),
			align: "center",
			sort: true
		},
		{id:"6",dataField: "OPEN", text: "OPEN",
			headerStyle: styledHead(80),
			align: "center",
			sort: true
		},
		{id:"7",dataField: "HIGH", text: "HIGH",
			headerStyle: styledHead(80),
			align: "center",
			sort: true
		},
		{id:"8",dataField: "LOW", text: "LOW",
			headerStyle: styledHead(80),
			align: "center",
			sort: true
		},
		{id:"9",dataField: "CHG %", text: "CHG %",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"10",dataField: "INTRA %", text: "INTRA %",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"11",dataField: "GAP %", text: "GAP %",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"12",dataField: "GAP FILL", text: "GAP FILL", 
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"13",dataField: "VOL %", text: "VOL %",
			headerStyle: styledHead(80),
			align: "center",
			sort: true
		},
		{id:"14",dataField: "PRE VOL%", text: "PRE VOL%",
			headerStyle: styledHead(110),
			align: "center",
			sort: true
			},
		{id:"15",dataField: "ALERT", text: "ALERT",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"16",dataField: "S2", text: "S2",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"17",dataField: "S1", text: "S1",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"18",dataField: "PIVOT", text: "PIVOT",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"19",dataField: "R1", text: "R1",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"20",dataField: "R2", text: "R2",
			headerStyle: styledHead(80),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"21",dataField: "NEW H L", text: "NEW H L",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"22",dataField: "NEAR", text: "NEAR",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"23",dataField: "DMA 5 13", text: "DMA 5 13",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"24",dataField: "200 DMA", text: "200 DMA",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"25",dataField: "OPEN =", text: "OPEN =",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"26",dataField: "LTP YEST", text: "LTP YEST",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"27",dataField: "AFT 10:15", text: "AFT 10:15",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"28",dataField: "AFT 2:45", text: "AFT 2:45",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"29",dataField: "NIFTY %", text: "NIFTY %",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"30",dataField: "BNIFTY %", text: "BNIFTY %",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		},
		{id:"31",dataField: "HOURLY", text: "HOURLY",
			headerStyle: styledHead(100),
			style: (cellContent) => styledVal(cellContent),
			align: "center",
			sort: true
		} 
	];
	
	const CaptionElement = () => <>
		<h3 style={{ borderRadius: '0.25em', textAlign: 'left', color: 'purple', border: '1px solid purple', padding: '0.5em' }}>StocksScreener</h3>
		<ul style={{color: 'black'}}>
			<li>
				<i><h6 >Click on column header to sort values and filter as required</h6></i>
			</li>
			<li>
				<i><h6 >Updated Every 10 seconds</h6></i>
			</li>
		</ul>
		</>;
	
	
	const expandRow = {
	  renderer: row => (
		<div>
		  <p>For more information, click here:  
		  <a target="_blank" href={`https://in.tradingview.com/symbols/NSE-${row["stocks"]}/`}> {row["stocks"]} </a></p>
		  
		</div>
	  ),
	  showExpandColumn: true,
	  expandByColumnOnly: true,
	  onExpand: (row, isExpand, rowIndex, e) => {
		}
	};
	
	const selectRow = {
	  mode: 'radio',
	  clickToSelect: true,
	  clickToExpand: true,
	  style: { backgroundColor: '#c8e6c9' }
	};
	
	return (
    <div className="App">
		<BootstrapTable id="table"
		  keyField="id"
		  data={ data }
		  columns={ columns }
		  striped
		  hover
		  condensed
		  noDataIndication={()=> "LOADING..." }
		  caption={<CaptionElement />}
		  expandRow={ expandRow }
		  selectRow={ selectRow }
		  filter={ filterFactory() }
		/>
    </div>
  );
}

export default App;